"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultAuth = exports.getDefaultStorage = exports.getApp = exports.getActualApp = exports.initialize = exports.initializeCompat = void 0;
const app_1 = require("firebase/app");
const auth_1 = require("firebase/auth");
const app_2 = __importDefault(require("firebase/compat/app"));
const firestore_1 = require("firebase/firestore");
const storage_1 = require("firebase/storage");
let _app;
let _firestore;
let _storage;
let _auth;
function initializeCompat(options, name) {
    if (_app === undefined) {
        console.log('@ht-web/firebase-adapter - Initialized Firebase in Compatibility Mode');
        _app = app_2.default.initializeApp(options, name);
        _auth = (0, auth_1.getAuth)(_app);
        _firestore = (0, firestore_1.initializeFirestore)(_app, {});
        _storage = (0, storage_1.getStorage)(_app);
    }
    return _app;
}
exports.initializeCompat = initializeCompat;
function initialize(options, name) {
    if (_app === undefined) {
        console.log('@ht-web/firebase-adapter - Initialized Firebase');
        _app = (0, app_1.initializeApp)(options, name);
        _auth = (0, auth_1.getAuth)(_app);
        _firestore = (0, firestore_1.initializeFirestore)(_app, {});
        _storage = (0, storage_1.getStorage)(_app);
    }
}
exports.initialize = initialize;
function getActualApp() {
    if (_app === undefined) {
        throw new FirebaseNotInitializedError();
    }
    return _app;
}
exports.getActualApp = getActualApp;
function getApp() {
    if (_firestore === undefined) {
        throw new FirebaseNotInitializedError();
    }
    return _firestore;
}
exports.getApp = getApp;
function getDefaultStorage() {
    if (_storage === undefined) {
        throw new FirebaseNotInitializedError();
    }
    return _storage;
}
exports.getDefaultStorage = getDefaultStorage;
function getDefaultAuth() {
    if (_auth === undefined) {
        throw new FirebaseNotInitializedError();
    }
    return _auth;
}
exports.getDefaultAuth = getDefaultAuth;
class FirebaseNotInitializedError extends Error {
    constructor() { super('Firebase is not initialized!'); }
}
